import * as types from "../actions/types";
import { removeItemFromArr } from "../../utils/common";
/******************* 
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  brandList: [],
  brandVehicleList: [],
  categoryList: [],
  addressInfo: {},
  dynamicPageList: [],
  locations: [],
  currentPage: "home",
  currentLocationId: "",
  slug: {},
  features: [],
  metaData: {},
  vehiclesMetaData: [],
  vehiclesList: [],
  totalRecord: "",
  cmsList: [],
  countries: [],
  states: [],
  cities: [],
  filterClickCount: 0,
  shareClickCount: 0,
  brandSlugArr: [],
  categorySlugArr: [],
  colorArr: [],
  selectedPage: "",
  selectedSlug: "",
  selectedSeat: [],
  selectedPrice: 0,
};

/******************* 
@purpose : Common Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function common(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /
    case types.SET_BRAND_LIST:
      return Object.assign({}, ini_data, {
        brandList: action.data,
      });

    case types.SET_CATEGORY_LIST:
      return Object.assign({}, ini_data, {
        categoryList: action.data,
      });

    case types.SET_VEHICLE_LIST_BY_BRAND:
      return Object.assign({}, ini_data, {
        brandVehicleList: action.data,
      });

    case types.SET_ADDRESS_INFO:
      return Object.assign({}, ini_data, {
        addressInfo: action.data,
      });
    case types.SET_DYNAMIC_PAGE_LIST:
      return Object.assign({}, ini_data, {
        dynamicPageList: action.data,
      });

    case types.SET_LOCATION_INFO:
      return Object.assign({}, ini_data, {
        locations: action.data,
      });

    case types.SET_CURRENT_PAGE:
      return Object.assign({}, ini_data, {
        currentPage: action.data,
      });

    case types.SET_CURRENT_LOCATION:
      return Object.assign({}, ini_data, {
        currentLocationId: action.data,
      });

    case types.SET_SLUGS:
      return Object.assign({}, ini_data, {
        slug: action.data,
      });

    case types.SET_FEATURES:
      return Object.assign({}, ini_data, {
        features: action.data,
      });

    case types.SET_META_DATA:
      return Object.assign({}, ini_data, {
        metaData: action.data,
      });

    case types.SET_VEHICLE_META_DATA:
      return Object.assign({}, ini_data, {
        vehiclesMetaData: action.data,
      });
    case types.SET_VEHICLE_LIST:
      return Object.assign({}, ini_data, {
        vehiclesList: [...ini_data.vehiclesList, ...action.data],
      });
    case types.SET_VEHICLE_LIST_CLEAR:
      return Object.assign({}, ini_data, {
        vehiclesList: [],
      });

    case types.SET_VEHICLE_TOTAL_RECORD:
      return Object.assign({}, ini_data, {
        totalRecord: action.data,
      });
    case types.SET_CMS_LIST:
      return Object.assign({}, ini_data, {
        cmsList: action.data,
      });

    case types.SET_COUNTRIES_LIST:
      return Object.assign({}, ini_data, {
        countries: action.data,
      });
    case types.SET_STATES_LIST:
      return Object.assign({}, ini_data, {
        states: action.data,
      });
    case types.SET_CITIES_LIST:
      return Object.assign({}, ini_data, {
        cities: action.data,
      });
    case types.UPDATE_FILTER_CLICK_COUNT:
      if (action.data) {
        return Object.assign({}, ini_data, {
          filterClickCount: ini_data.filterClickCount + 1,
        });
      } else {
        return Object.assign({}, ini_data, {
          filterClickCount: 0,
        });
      }
    case types.UPDATE_SHARE_CLICK_COUNT:
      if (action.data) {
        return Object.assign({}, ini_data, {
          shareClickCount: ini_data.shareClickCount + 1,
        });
      } else {
        return Object.assign({}, ini_data, {
          shareClickCount: 0,
        });
      }
    case types.SET_SELECTED_PAGE:
      return Object.assign({}, ini_data, {
        selectedPage: action.data,
      });
    case types.SET_SELECTED_SLUG:
      return Object.assign({}, ini_data, {
        selectedSlug: action.data,
      });
    case types.ADD_REMOVE_BRAND_CATEGORY_SLUG:
      let arr = "";
      if (ini_data.selectedPage != "category") {
        // brand page
        if (action.data.flag) {
          // add slug from category slug arr
          arr = ini_data.categorySlugArr;
          arr.push(action.data.slug);
        } else {
          // remove slug from category slug arr
          arr = removeItemFromArr(ini_data.categorySlugArr, action.data.slug);
        }
        return Object.assign({}, ini_data, {
          categorySlugArr: arr,
        });
      } else {
        // category page
        if (action.data.flag) {
          // add slug from category slug arr
          arr = ini_data.brandSlugArr;
          arr.push(action.data.slug);
        } else {
          // remove slug from category slug arr
          arr = removeItemFromArr(ini_data.brandSlugArr, action.data.slug);
        }
        return Object.assign({}, ini_data, {
          brandSlugArr: arr,
        });
      }

    case types.ADD_REMOVE_COLOR:
      let arr1 = "";
      if (action.data.flag) {
        // add slug from category slug arr
        arr1 = ini_data.colorArr;
        arr1.push(action.data.id);
      } else {
        // remove slug from category slug arr
        arr1 = removeItemFromArr(ini_data.colorArr, action.data.id);
      }
      return Object.assign({}, ini_data, {
        colorArr: arr1,
      });

    case types.ADD_REMOVE_SEAT:
      let arr2 = []; // Ensure arr2 is initialized as an array
      const selectedSeat = Array.isArray(ini_data.selectedSeat)
        ? ini_data.selectedSeat
        : []; // Ensure selectedSeat is an array

      if (action.data.flag) {
        // Add the value to the selectedSeat array
        arr2 = [...selectedSeat, action.data.value];
      } else {
        // Remove the value from the selectedSeat array
        arr2 = removeItemFromArr(selectedSeat, action.data.value);
      }

      return {
        ...ini_data, // Spread the current state
        selectedSeat: arr2, // Update the selectedSeat
      };

    case types.ADD_REMOVE_PRICE:
      let value1 = 0;
      if (action.data.flag) {
        value1 = action.data.value;
      }
      return Object.assign({}, ini_data, {
        selectedPrice: value1,
      });

    case types.CLEAR_CATEGORY_BRAND_COLOR_SEAT_PRICE:
      return Object.assign({}, ini_data, {
        brandSlugArr: [],
        categorySlugArr: [],
        colorArr: [],
        selectedSeat: 0,
        selectedPrice: 0,
      });

    default:
      return ini_data;
  }
}
